export class User {
  typeUtilisateur: number;
  idPaysLPC: number;
  nom: string;
  prenom: string;
  civilite: string;
  email: string;
  pseudo: string;
  adresse1: string;
  adresse2: string;
  codePostal: string;
  ville: string;
  telephone: string;
  acceptationInformationsKNE: boolean;
  motDePasse: string;
  uai: Array<string>;
  dateDerniereConnexion: string;
  // token: string;
  // username: string;
  // bio: string;
  // image: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.model.ts